export default __webpack_public_path__ + "static/card-web-sdk-d44ff3e2e661fe6f25a02f5a26fbb1bd.png";